import { render, staticRenderFns } from "./DParentColumnPreview.vue?vue&type=template&id=101572d7&"
import script from "./DParentColumnPreview.vue?vue&type=script&lang=js&"
export * from "./DParentColumnPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports